exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".PointProgress{display:flex;align-items:center;justify-content:center}.PointProgress .ant-pagination-item{border:none}.PointProgress .ant-pagination-item-active .point{border-color:#00adff}.PointProgress .ant-pagination-next,.PointProgress .ant-pagination-prev{display:none}.PointProgress .point{margin-top:6px;margin-left:6px;width:20px;height:20px;background:#fff;border:2px solid #d8d8d8;cursor:pointer;border-radius:50%}.PointProgress .point.isTrue{background-color:#95de64}.PointProgress .point.isFalse{background-color:#ff7875}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./yii2/frontend/frontend-assets/src/components/QuestionMultyView/components/PointProgress/style.module.scss
// module id = 5255
// module chunks = 0